module.exports = __webpack_public_path__ + "static/c13-2ec691951366ffdc2fab8435e92048aa.jpg";